/**
 * Cart reservation timer – 10 minutes countdown.
 * Starts when the first item lands in the cart, persists across page loads
 * via localStorage. Resets when the cart is emptied.
 */

(function () {
  const STORAGE_KEY = 'cart_timer_deadline';
  const DURATION_MS = 10 * 60 * 1000; // 10 minutes

  function getDeadline() {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? parseInt(stored, 10) : null;
  }

  function setDeadline(ts) {
    localStorage.setItem(STORAGE_KEY, String(ts));
  }

  function clearDeadline() {
    localStorage.removeItem(STORAGE_KEY);
  }

  function formatTime(ms) {
    if (ms <= 0) return '00:00';
    const totalSeconds = Math.ceil(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  function getAllTimerElements() {
    return document.querySelectorAll('.cart-timer');
  }

  function updateDisplay(remainingMs) {
    getAllTimerElements().forEach(function (el) {
      const display = el.querySelector('.cart-timer__countdown');
      if (!display) return;
      display.textContent = formatTime(remainingMs);

      // Turn red in the last 2 minutes
      if (remainingMs <= 2 * 60 * 1000) {
        el.classList.add('cart-timer--urgent');
      } else {
        el.classList.remove('cart-timer--urgent');
      }
    });
  }

  function showTimers() {
    getAllTimerElements().forEach(function (el) {
      el.style.display = '';
    });
  }

  function hideTimers() {
    getAllTimerElements().forEach(function (el) {
      el.style.display = 'none';
    });
  }

  let tickInterval = null;

  function startTick() {
    if (tickInterval) return;
    tickInterval = setInterval(function () {
      const deadline = getDeadline();
      if (!deadline) {
        stopTick();
        hideTimers();
        return;
      }
      const remaining = deadline - Date.now();
      if (remaining <= 0) {
        stopTick();
        clearDeadline();
        updateDisplay(0);
        // Optionally clear the cart here or just hide
        setTimeout(function () {
          hideTimers();
        }, 2000);
        return;
      }
      updateDisplay(remaining);
    }, 500);
  }

  function stopTick() {
    if (tickInterval) {
      clearInterval(tickInterval);
      tickInterval = null;
    }
  }

  function initTimer(itemCount) {
    if (itemCount > 0) {
      let deadline = getDeadline();
      if (!deadline) {
        deadline = Date.now() + DURATION_MS;
        setDeadline(deadline);
      }
      const remaining = deadline - Date.now();
      updateDisplay(remaining);
      showTimers();
      startTick();
    } else {
      stopTick();
      clearDeadline();
      hideTimers();
    }
  }

  // Listen for cart changes fired by the theme
  document.addEventListener('cart:change', function (event) {
    const itemCount = event.detail && event.detail.cart ? event.detail.cart.item_count : 0;
    initTimer(itemCount);
  });

  // On full page load check localStorage + fetch cart count
  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        initTimer(cart.item_count);
      })
      .catch(function () {});
  });
})();
